import { useEffect, useState } from 'react';
import { notificationService } from 'services/notification.service';

const useNotificationList = (
    payload = {
        skip: 0,
        limit: 2
    }
) => {
    const [notifications, setNotifications] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const handleApi = async () => {
        try {
            setIsLoading(true);
            const response = await notificationService.getNotificationList(payload);
            setNotifications(response.data.data)
        } catch (err) {
            console.log(err)
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        handleApi();
    }, [payload?.limit]);

    return { notificationsData: notifications, isLoading };
}

export default useNotificationList;